import { IUser } from 'src/app/models/user';
import { createReducer, on, Action } from '@ngrx/store';
import * as GraphActions from './graph.action';

export const initialState: IUser = {
};

const graphApiReducer = createReducer(initialState,
  on(GraphActions.SuccessGetGraphDetailsApiAction, (state, { graphDetails }) => ({ ...state, ...graphDetails })),
  on(GraphActions.ErrorGetGraphDetailsApiAction, (state, error) => ({ ...state, error })),
);

export function GraphApiReducer(state: IUser | undefined, action: Action) {
  return graphApiReducer(state, action);
}
